import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React from 'react';

const StoryblokCarouselListingSlide = ({ blok }) => {
  const { listing } = blok;

  const hasListing = listing && listing.length > 0;
  if (!hasListing) return null;

  return (
    <Box {...storyblokEditable(blok)} key={blok._uid}>
      <StoryblokComponent blok={listing[0]} key={listing[0]._uid} />
    </Box>
  );
};

export default StoryblokCarouselListingSlide;
